/**
 * @file: 保存
 * @author: xiaolong.huang@dmall.com
 */

import { StageEvent } from '../../message/index';
import ShortCutKey from '../shortcutkey/index';

function trigger(): void {
    StageEvent.fire('savePage', {
        eventFrom: 'stage'
    });
}

export default {
    trigger
};
